import { LoginResponse, MFAResponse, MultiTenantLoginResponse } from './types'

export const isMFAResponse = (response: LoginResponse): response is MFAResponse => {
    return response.hasOwnProperty('uri')
}

export const isMultiTenantResponse = (response: LoginResponse): response is MultiTenantLoginResponse => {
    return response.hasOwnProperty('tenants')
}
